import { jsonEqual, valueAt } from './json'
import type { UnknownPath } from './unknown'

export class FcdcGuardError extends Error {
  readonly path: string

  constructor(path: string) {
    super(`Refusing to save: unknown path "${path}" would change`)
    this.name = 'FcdcGuardError'
    this.path = path
    Object.setPrototypeOf(this, new.target.prototype)
  }
}

/** Block a save whose body would overwrite a path the client did not understand. */
export function assertUnknownPathsUntouched(
  raw: unknown,
  body: unknown,
  unknownPaths: readonly UnknownPath[]
): void {
  for (const path of unknownPaths) {
    if (jsonEqual(valueAt(raw, path), valueAt(body, path))) {
      continue
    }

    console.error('FCDC guard blocked a save', path)
    throw new FcdcGuardError(path)
  }
}
